import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLUE_400, InfoTag, Typography, getTestId } from '@airtel/air-design-system';
import { View } from 'react-native';
import { TEXT_TYPE } from '../../TaskCardWidgetConstants';
import { getSingleDetailsFieldStyles } from './SingleTaskDetailsStyles';
export var SingleTaskDetailsField = props => {
  var innerItem = props.innerItem,
    isMobileScreen = props.isMobileScreen,
    index = props.index,
    onUserAction = props.onUserAction;
  var singleDetailsFieldStyles = getSingleDetailsFieldStyles();
  var isAccessible = (innerItem === null || innerItem === void 0 ? void 0 : innerItem.accessibilityProps) ? false : true;
  return _jsx(View, Object.assign({
    style: [singleDetailsFieldStyles.singleBlockDetailsContainer, index % 2 == 0 && singleDetailsFieldStyles.leftColumn]
  }, {
    children: _jsx(View, Object.assign({
      style: singleDetailsFieldStyles.detailsSingleBlockWrapper
    }, innerItem === null || innerItem === void 0 ? void 0 : innerItem.accessibilityProps, {
      children: !!innerItem.key && innerItem.key !== '' && _jsxs(View, Object.assign({
        style: singleDetailsFieldStyles.detailsSingleBlock
      }, {
        children: [_jsx(Typography, Object.assign({}, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'key'), {
          type: isMobileScreen ? TEXT_TYPE.BODY_SINGLE_LINE_XS : TEXT_TYPE.BODY_SINGLE_LINE_SM,
          text: innerItem.key,
          color: BLACK_700,
          accessible: isAccessible
        })), _jsx(Typography, Object.assign({}, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'value'), {
          type: isMobileScreen ? TEXT_TYPE.BODY_PARA_SM_BOLD : TEXT_TYPE.BODY_PARA_MD_BOLD,
          isHyperLink: innerItem === null || innerItem === void 0 ? void 0 : innerItem.isClickable,
          color: (innerItem === null || innerItem === void 0 ? void 0 : innerItem.isClickable) ? BLUE_400 : undefined,
          text: (innerItem === null || innerItem === void 0 ? void 0 : innerItem.value) !== '' ? innerItem === null || innerItem === void 0 ? void 0 : innerItem.value : '-',
          style: singleDetailsFieldStyles.marginValue,
          accessible: isAccessible,
          onPress: event => {
            (innerItem === null || innerItem === void 0 ? void 0 : innerItem.onPressValueMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, innerItem === null || innerItem === void 0 ? void 0 : innerItem.onPressValueMetaData), event));
          }
        })), !!(innerItem === null || innerItem === void 0 ? void 0 : innerItem.description) && _jsx(Typography, {
          type: isMobileScreen ? TEXT_TYPE.BODY_PARA_SM : TEXT_TYPE.BODY_PARA_MD,
          text: innerItem === null || innerItem === void 0 ? void 0 : innerItem.description,
          style: singleDetailsFieldStyles.marginValue,
          accessible: isAccessible
        }), !!(innerItem === null || innerItem === void 0 ? void 0 : innerItem.infoTagText) && _jsx(InfoTag, {
          type: "inline",
          subType: innerItem === null || innerItem === void 0 ? void 0 : innerItem.infoTagSubType,
          text: innerItem === null || innerItem === void 0 ? void 0 : innerItem.infoTagText,
          style: singleDetailsFieldStyles.infoTag,
          accessible: isAccessible
        })]
      }))
    }))
  }));
};
export default SingleTaskDetailsField;